<template>
	<div class="school-solution-page">
		<Head />
		<main class="school-main">
			<section class="hero section-py">
				<div class="container-custom hero-grid">
					<div>
						<div class="hero-badge">中小学心理健康一体化解决方案</div>
						<h1>中小学心理测评与<br>心理健康管理系统</h1>
						<p>
							以<span>专业·智能·守护·成长</span>为核心理念，构建覆盖全学段、全流程的心理健康防护网，落实国家政策要求，守护青少年身心健康成长。
						</p>
						<div class="hero-actions">
							<a href="#contact" class="btn-primary">获取学校专属方案</a>
							<a href="#function" class="btn-outline">查看核心功能</a>
						</div>
						<div class="hero-points">
							<div><i class="el-icon-success"></i>学段专属量表</div>
							<div><i class="el-icon-success"></i>智能分级预警</div>
							<div><i class="el-icon-success"></i>家校协同共育</div>
						</div>
					</div>
					<div class="hero-image-wrap">
						<img src="https://picsum.photos/900/560?random=60" alt="中小学心理测评系统界面">
					</div>
				</div>
			</section>

			<section id="background" class="section-py">
				<div class="container-custom">
					<div class="section-head">
						<h2>项目背景与建设目标</h2>
						<div class="title-underline"></div>
						<p>政策引领 + 目标导向，构建科学完善的中小学心理健康管理体系。</p>
					</div>
					<div class="two-grid">
						<div class="card card-hover">
							<h3 class="gradient-text">政策引领，势在必行</h3>
							<div class="stack-list">
								<div v-for="item in policyList" :key="item.title" class="stack-item">
									<h4>{{ item.title }}</h4>
									<p>{{ item.desc }}</p>
								</div>
							</div>
						</div>
						<div class="card card-hover">
							<h3 class="gradient-text">六大建设目标</h3>
							<div class="goal-grid">
								<div v-for="item in goalList" :key="item.title" class="goal-item">
									<h4>{{ item.title }}</h4>
									<p>{{ item.desc }}</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>

			<section id="painpoints" class="section-py section-soft">
				<div class="container-custom">
					<div class="section-head">
						<h2>现状痛点与核心需求</h2>
						<div class="title-underline"></div>
						<p>精准洞察校园心理健康工作难点，针对性提供系统化解决方案。</p>
					</div>
					<div class="two-grid">
						<div class="card card-hover">
							<h3 class="gradient-text">六大核心痛点</h3>
							<div class="number-list">
								<div v-for="(item, index) in painpointList" :key="item.title" class="number-item">
									<span>{{ `0${index + 1}`.slice(-2) }}</span>
									<div>
										<h4>{{ item.title }}</h4>
										<p>{{ item.desc }}</p>
									</div>
								</div>
							</div>
						</div>
						<div class="card card-hover">
							<h3 class="gradient-text">四大核心需求</h3>
							<div class="demand-list">
								<div v-for="item in demandList" :key="item.title" class="demand-item">
									<h4>{{ item.title }}</h4>
									<p>{{ item.desc }}</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>

			<section id="design" class="section-py">
				<div class="container-custom">
					<div class="section-head">
						<h2>系统整体设计</h2>
						<div class="title-underline"></div>
						<p>六大设计原则 + 先进架构 + 五级权限，打造专业可靠系统。</p>
					</div>
					<div class="three-grid">
						<div class="card card-hover">
							<h3 class="gradient-text">六大设计原则</h3>
							<ul class="plain-list">
								<li v-for="item in principleList" :key="item">{{ item }}</li>
							</ul>
						</div>
						<div class="card card-hover">
							<h3 class="gradient-text">先进 B/S 架构设计</h3>
							<div class="stack-list">
								<div v-for="item in architectureList" :key="item.title" class="stack-item">
									<h4>{{ item.title }}</h4>
									<p>{{ item.desc }}</p>
								</div>
							</div>
						</div>
						<div class="card card-hover">
							<h3 class="gradient-text">五级角色权限</h3>
							<ul class="plain-list">
								<li v-for="item in roleList" :key="item">{{ item }}</li>
							</ul>
						</div>
					</div>
				</div>
			</section>

			<section id="function" class="section-py section-soft">
				<div class="container-custom">
					<div class="section-head">
						<h2>核心功能模块详解</h2>
						<div class="title-underline"></div>
						<p>四大核心模块，覆盖校园心理健康工作全流程。</p>
					</div>
					<div class="function-grid">
						<div v-for="item in functionList" :key="item.title" class="card card-hover">
							<h3>{{ item.title }}</h3>
							<ul class="desc-list">
								<li v-for="point in item.points" :key="point">{{ point }}</li>
							</ul>
						</div>
					</div>
				</div>
			</section>

			<section id="support" class="section-py">
				<div class="container-custom">
					<div class="section-head">
						<h2>部署实施与安全保障</h2>
						<div class="title-underline"></div>
						<p>灵活部署 + 多重保障，确保系统稳定落地与安全运行。</p>
					</div>
					<div class="two-grid">
						<div class="card card-hover">
							<h3 class="gradient-text">灵活部署，快速落地</h3>
							<ul class="desc-list">
								<li v-for="item in deployList" :key="item">{{ item }}</li>
							</ul>
						</div>
						<div class="card card-hover">
							<h3 class="gradient-text">多重安全保障</h3>
							<ul class="desc-list">
								<li v-for="item in securityList" :key="item">{{ item }}</li>
							</ul>
						</div>
					</div>
				</div>
			</section>

			<section class="result-section">
				<div class="container-custom result-box">
					<h2>服务支持与方案亮点</h2>
					<div class="result-grid">
						<div class="result-card card-hover">
							<h3>全方位售后服务保障</h3>
							<ul>
								<li v-for="item in serviceList" :key="item">{{ item }}</li>
							</ul>
						</div>
						<div class="result-card card-hover">
							<h3>中小学专属方案亮点</h3>
							<ul>
								<li v-for="item in highlightList" :key="item">{{ item }}</li>
							</ul>
						</div>
					</div>
					
				</div>
			</section>
			<SiteFooter />
		</main>
	</div>
</template>

<script>
import Head from '@/components/head/index.vue'
import SiteFooter from '@/components/footer/index.vue'

export default {
	name: 'SchoolSolution',
	components: {
		Head,
		SiteFooter
	},
	data() {
		return {
			policyList: [
				{
					title: '国家政策高度重视',
					desc: '国家连续出台心理健康教育指导文件，将学生心理健康提升至战略高度。'
				},
				{
					title: '机制与规划要求明确',
					desc: '要求建立健全早期发现与干预机制，将心理健康教育纳入教育发展规划。'
				},
				{
					title: '系统建设势在必行',
					desc: '建设专业高效系统，成为落实政策和提升学校心理健康工作水平的关键抓手。'
				}
			],
			goalList: [
				{
					title: '全流程覆盖',
					desc: '覆盖全体学生、全学段、全流程。'
				},
				{
					title: '家校协同共育',
					desc: '教师、心理师、学校、家长协同平台。'
				},
				{
					title: '量表精准适配',
					desc: '不同学段匹配专属专业量表。'
				},
				{
					title: '档案规范管理',
					desc: '建立合规安全的电子心理档案。'
				},
				{
					title: '风险智能预警',
					desc: '自动分级预警、快速上报、闭环干预。'
				},
				{
					title: '数据决策支撑',
					desc: '为学校管理与决策提供数据支持。'
				}
			],
			painpointList: [
				{
					title: '测评低效',
					desc: '传统纸质测评耗时耗力，难支撑大规模筛查。'
				},
				{
					title: '档案混乱',
					desc: '数据零散，缺少标准化电子档案与长期追踪。'
				},
				{
					title: '量表不适配',
					desc: '通用成人量表不贴合学生认知和心理特征。'
				},
				{
					title: '家校脱节',
					desc: '家长参与不足，导致学校干预在家庭场景中衰减。'
				},
				{
					title: '预警滞后',
					desc: '缺乏实时风险预警机制，常常问题爆发后才介入。'
				},
				{
					title: '师资不足',
					desc: '专职心理教师紧缺，亟需数字工具提升效率。'
				}
			],
			demandList: [
				{
					title: '学段分层需求',
					desc: '小学、初中、高中差异化测评与关怀。'
				},
				{
					title: '安全需求',
					desc: '严格数据与隐私保护，满足法规要求。'
				},
				{
					title: '功能需求',
					desc: '在线测评、预警、档案、干预、家校互通。'
				},
				{
					title: '易用性需求',
					desc: '界面简洁直观，降低学习与使用门槛。'
				}
			],
			principleList: [
				'专业性：权威认证量表，科学严谨',
				'安全性：全链路加密，隐私合规',
				'实用性：贴合校园流程，操作轻量化',
				'分层性：区分学段模块，精准匹配',
				'闭环性：从发现到干预全流程闭环',
				'兼容性：多终端适配，访问便捷'
			],
			architectureList: [
				{
					title: '用户层',
					desc: 'PC端、移动端、微信小程序多终端适配'
				},
				{
					title: '应用功能层',
					desc: '测评管理、预警干预、档案管理、家校协同'
				},
				{
					title: '数据服务层',
					desc: '量表库、用户库、档案库、预警库统一管理'
				},
				{
					title: '安全防护层',
					desc: '数据加密、权限控制、日志审计'
				}
			],
			roleList: [
				'校级管理员：系统配置、全局数据、统筹协调',
				'心理教师：测评、预警处置、档案与干预',
				'班主任：发起测评、日常关怀、异常上报',
				'学生：在线测评、查看脱敏报告',
				'家长：查看通知、协同关怀、家校沟通'
			],
			functionList: [
				{
					title: '核心模块一：智能测评管理',
					points: ['学段专属量表库，精准适配', '灵活测评任务编排与进度监控', '防作弊策略保障数据真实可靠']
				},
				{
					title: '核心模块二：风险预警与危机管理',
					points: ['红橙黄绿四级自动预警', '从预警到干预回访全流程闭环', '标准化危机预案一键联动']
				},
				{
					title: '核心模块三：档案管理与统计分析',
					points: ['一生一档动态更新', '多维统计分析与趋势图表', '报表支持 Excel/PDF 导出']
				},
				{
					title: '核心模块四：家校协同与资源支持',
					points: ['家长端轻量入口便捷接入', '家校沟通在线留痕可追踪', '分学段心理资源持续供给']
				}
			],
			deployList: [
				'支持云部署与本地私有化部署，按学校需求灵活选择。',
				'4周落地：需求对接、分层培训、全员测评、试运行启动。',
				'支持阶段复盘和优化，快速进入常态化使用。'
			],
			securityList: [
				'严格遵循个人信息保护相关法律法规。',
				'传输与存储全程加密，防止敏感数据泄露。',
				'分角色精细权限控制，最小化访问原则。',
				'全量操作日志留痕，支持审计与责任追溯。'
			],
			serviceList: [
				'7x12小时技术支持，快速响应',
				'量表与系统功能持续升级',
				'分层专项培训，确保熟练使用',
				'年度巡检与深度使用指导'
			],
			highlightList: [
				'学段精准适配，量表语言通俗',
				'危机闭环管理，操作落地性强',
				'隐私保护优先，避免心理标签化',
				'家校深度协同，形成教育合力'
			],
			contactPersons: [
				{
					name: '张先生',
					phone: '13161072501'
				},
				{
					name: '许女士',
					phone: '15031192537'
				},
				{
					name: '安先生',
					phone: '18932907651'
				}
			],
			consultationForm: {
				name: '',
				phone: '',
				org: '',
				grade: '',
				desc: ''
			}
		}
	},
	mounted() {
		this.scrollToHashTarget()
	},
	watch: {
		'$route.hash'() {
			this.scrollToHashTarget()
		}
	},
	methods: {
		scrollToHashTarget() {
			if (!this.$route.hash) {
				return
			}
			this.$nextTick(() => {
				const target = document.querySelector(this.$route.hash)
				if (target) {
					target.scrollIntoView({
						behavior: 'smooth',
						block: 'start'
					})
				}
			})
		},
		handleConsultSubmit() {
			window.alert('咨询信息提交成功！我们将在1个工作日内与您联系。')
			this.consultationForm = {
				name: '',
				phone: '',
				org: '',
				grade: '',
				desc: ''
			}
		}
	}
}
</script>

<style scoped>
.school-solution-page {
	min-height: 100vh;
	background: #f7fafc;
	color: #2d3748;
}

.school-main {
	padding-top: 64px;
}

.section-py {
	padding: 64px 0;
}

.section-soft {
	background: #f2f8f7;
}

.container-custom {
	max-width: 1260px;
	margin: 0 auto;
	padding: 0 20px;
}

.section-head {
	max-width: 780px;
	margin: 0 auto 40px;
	text-align: center;
}

.section-head h2 {
	margin: 0;
	font-size: clamp(30px, 4vw, 46px);
	line-height: 1.3;
}

.section-head p {
	margin: 0;
	font-size: 17px;
	line-height: 1.75;
	color: #5c6b7a;
}

.title-underline {
	width: 66px;
	height: 5px;
	margin: 18px auto;
	border-radius: 999px;
	background: #f9b342;
}

.hero {
	background: linear-gradient(135deg, rgba(74, 157, 150, 0.08) 0%, rgba(126, 196, 189, 0.1) 100%);
}

.hero-grid {
	display: grid;
	grid-template-columns: repeat(2, minmax(0, 1fr));
	gap: 30px;
	align-items: center;
}

.hero-badge {
	display: inline-block;
	padding: 8px 14px;
	margin-bottom: 10px;
	border-radius: 999px;
	font-size: 13px;
	color: #4a9d96;
	background: rgba(74, 157, 150, 0.12);
}

.hero h1 {
	margin: 0 0 14px;
	font-size: clamp(34px, 5vw, 62px);
	line-height: 1.25;
}

.hero p {
	margin: 0;
	font-size: 18px;
	line-height: 1.75;
	color: #4a5568;
}

.hero p span {
	font-weight: 700;
	color: #4a9d96;
}

.hero-actions {
	display: flex;
	flex-wrap: wrap;
	gap: 12px;
	margin: 24px 0 16px;
}

.btn-primary,
.btn-outline {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	padding: 12px 24px;
	border-radius: 10px;
	font-size: 15px;
	font-weight: 600;
	text-decoration: none;
	border: 1px solid transparent;
	cursor: pointer;
}

.btn-primary {
	background: #4a9d96;
	border-color: #4a9d96;
	color: #fff;
}

.btn-primary:hover {
	background: #3f8b85;
}

.btn-primary.full {
	width: 100%;
}

.btn-outline {
	color: #4a9d96;
	border-color: #4a9d96;
	background: transparent;
}

.btn-outline:hover {
	background: rgba(74, 157, 150, 0.06);
}

.hero-points {
	display: grid;
	grid-template-columns: repeat(3, minmax(0, 1fr));
	gap: 8px;
}

.hero-points div {
	display: inline-flex;
	align-items: center;
	gap: 6px;
	font-size: 14px;
	color: #4a5568;
}

.hero-points i {
	color: #4a9d96;
}

.hero-image-wrap {
	background: #fff;
	padding: 10px;
	border-radius: 16px;
	border: 1px solid #dbe8e6;
	box-shadow: 0 12px 28px rgba(74, 157, 150, 0.15);
}

.hero-image-wrap img {
	display: block;
	width: 100%;
	height: auto;
	border-radius: 10px;
}

.card,
.contact-form {
	background: #fff;
	border: 1px solid #d7ebe7;
	border-radius: 14px;
	padding: 22px 18px;
	box-shadow: 0 4px 18px rgba(74, 157, 150, 0.08);
}

.card-hover {
	transition: all 0.35s ease;
}

.card-hover:hover {
	transform: translateY(-6px);
	box-shadow: 0 10px 30px rgba(74, 157, 150, 0.14);
}

.two-grid {
	display: grid;
	grid-template-columns: repeat(2, minmax(0, 1fr));
	gap: 18px;
}

.three-grid {
	display: grid;
	grid-template-columns: repeat(3, minmax(0, 1fr));
	gap: 16px;
}

.stack-list {
	display: flex;
	flex-direction: column;
	gap: 10px;
}

.stack-item {
	padding-left: 12px;
	border-left: 4px solid #4a9d96;
	margin-bottom: 20px;
}

.stack-item h4,
.goal-item h4,
.number-item h4,
.demand-item h4,
.phase-item h4,
.responsibility-list h4 {
	margin: 0;
	font-size: 17px;
}

.stack-item p,
.goal-item p,
.number-item p,
.demand-item p,
.phase-item p,
.responsibility-list p {
	margin: 4px 0 0;
	font-size: 14px;
	line-height: 1.7;
	color: #5c6b7a;
}

.gradient-text {
	margin: 0 0 14px;
	font-size: 24px;
	background: linear-gradient(90deg, #4a9d96, #7ec4bd);
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;
	background-clip: text;
	color: transparent;
}

.goal-grid {
	display: grid;
	grid-template-columns: repeat(2, minmax(0, 1fr));
	gap: 10px;
}

.goal-item,
.demand-item,
.safe-item {
	padding: 10px;
	border-radius: 10px;
	border: 1px solid #e2efec;
	background: #f7fbfa;
	margin-bottom: 8px;
}

.number-list,
.demand-list {
	display: flex;
	flex-direction: column;
	gap: 10px;
}

.number-item {
	display: flex;
	align-items: flex-start;
	gap: 8px;
}

.number-item span {
	width: 28px;
	height: 28px;
	border-radius: 50%;
	background: #4a9d96;
	color: #fff;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	font-size: 12px;
	font-weight: 700;
	flex-shrink: 0;
}

.plain-list,
.desc-list,
.result-card ul {
	margin: 0;
	padding: 0;
	list-style: none;
}

.plain-list li,
.desc-list li,
.result-card li {
	position: relative;
	padding-left: 12px;
	font-size: 18px;
	line-height: 1.7;
	color: #5c6b7a;
	margin-bottom: 26px;
}

.plain-list li::before,
.desc-list li::before,
.result-card li::before {
	content: '•';
	position: absolute;
	left: 0;
	color: #4a9d96;
}

.function-grid {
	display: grid;
	grid-template-columns: repeat(2, minmax(0, 1fr));
	gap: 16px;
}

.function-grid h3 {
	margin: 0 0 10px;
	font-size: 22px;
}

.result-section {
	padding: 58px 0;
	background: linear-gradient(90deg, #4a9d96 0%, #7ec4bd 100%);
}

.result-box {
	max-width: 980px;
	text-align: center;
}

.result-box h2 {
	margin: 0 0 18px;
	font-size: 34px;
	color: #fff;
}

.result-grid {
	display: grid;
	grid-template-columns: repeat(2, minmax(0, 1fr));
	gap: 14px;
	margin-bottom: 20px;
}

.result-card {
	padding: 18px 14px;
	border-radius: 12px;
	background: rgba(255, 255, 255, 0.12);
	border: 1px solid rgba(255, 255, 255, 0.3);
}

.result-card h3 {
	margin: 0 0 10px;
	color: #fff;
	font-size: 20px;
}

.result-card li {
	color: rgba(255, 255, 255, 0.9);
	text-align: left;
}

.result-card li::before {
	color: #fff;
}

.result-btn {
	display: inline-flex;
	padding: 12px 24px;
	border-radius: 10px;
	background: #fff;
	color: #4a9d96;
	font-weight: 700;
	text-decoration: none;
}

.contact-grid {
	display: grid;
	grid-template-columns: 2fr 1fr;
	gap: 18px;
}

.contact-form {
	background: #f8fafc;
}

.form-grid {
	display: grid;
	grid-template-columns: repeat(2, minmax(0, 1fr));
	gap: 12px;
}

.form-item {
	margin-bottom: 12px;
}

.form-item label {
	display: block;
	margin-bottom: 6px;
	font-size: 14px;
	color: #374151;
}

.form-item input,
.form-item select,
.form-item textarea {
	width: 100%;
	box-sizing: border-box;
	padding: 10px 12px;
	font-size: 14px;
	border: 1px solid #d5e3df;
	border-radius: 8px;
	outline: none;
}

.form-item input:focus,
.form-item select:focus,
.form-item textarea:focus {
	border-color: #4a9d96;
	box-shadow: 0 0 0 3px rgba(74, 157, 150, 0.16);
}

.contact-aside {
	border-radius: 14px;
	padding: 24px 20px;
	color: #fff;
	background: linear-gradient(135deg, #4a9d96 0%, #7ec4bd 100%);
}

.contact-aside h3 {
	margin: 0 0 18px;
	font-size: 30px;
}

.person-list {
	display: flex;
	flex-direction: column;
	gap: 12px;
}

.person-item {
	display: flex;
	align-items: center;
	gap: 10px;
}

.person-icon {
	width: 42px;
	height: 42px;
	border-radius: 50%;
	background: rgba(255, 255, 255, 0.2);
	display: flex;
	align-items: center;
	justify-content: center;
}

.person-name {
	margin: 0 0 2px;
	font-size: 13px;
	opacity: 0.82;
}

.person-phone {
	margin: 0;
	font-size: 20px;
	font-weight: 600;
}

.company {
	margin-top: 20px;
	padding-top: 12px;
	border-top: 1px solid rgba(255, 255, 255, 0.25);
}

.company p {
	margin: 0 0 4px;
	font-size: 13px;
	opacity: 0.82;
}

.company h4 {
	margin: 0;
	font-size: 20px;
}

@media (max-width: 1200px) {
	.three-grid {
		grid-template-columns: 1fr;
	}
}

@media (max-width: 992px) {
	.school-main {
		padding-top: 56px;
	}

	.section-py {
		padding: 48px 0;
	}

	.hero-grid,
	.two-grid,
	.contact-grid {
		grid-template-columns: 1fr;
	}

	.hero-points {
		grid-template-columns: 1fr;
	}
}

@media (max-width: 768px) {
	.container-custom {
		padding: 0 14px;
	}

	.section-py {
		padding: 34px 0;
	}

	.form-grid,
	.goal-grid,
	.function-grid,
	.result-grid {
		grid-template-columns: 1fr;
	}

	.hero h1 {
		font-size: 32px;
	}

	.hero p,
	.section-head p {
		font-size: 14px;
	}

	.result-box h2 {
		font-size: 26px;
	}
}
</style>
